import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=3fbb2b0d"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=3fbb2b0d&prod&lang=scss"
import style1 from "./Chat.vue?vue&type=style&index=1&id=3fbb2b0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports